import {message} from 'antd'

/**
 * Basic request handler with default error handling.
 *
 * @param makeRequest:    function that returns promise
 * @param thenFnc:        function that will run on response object (e. g. 'json' to run response.json())
 * @param onNokResponse:  JSON with error codes (404, 500 etc.) as keys for appropriate error handling functions
 * @param onFinally:      on finally callback
 * @param onFail:         on fail callback
 */
export const requestHandler = async (makeRequest, thenFnc, onNokResponse, onFinally, onFail) => {
  try {
    const response = await makeRequest()
    if (!response.ok) {
      (onNokResponse?.[response.status]) ? (
        onNokResponse[response.status](response)
      ) : (
        defaultErrorHandler(response)
      )
      return response
    }

    return (thenFnc) ? response[thenFnc]() : response
  } catch (error) {
    if (onFail) {
      onFail(error)
    } else {
      defaultErrorHandler(error)
    }
  } finally {
    if (onFinally) {
      onFinally()
    }
  }
}

export const defaultErrorHandler = response => {
  console.warn(response)
  const responseJson = response.json()
  responseJson ? responseJson.then(r => (
    message.error(response.status + ' – ' + (r?.error?.message ? r?.error?.message : 'Unknown error'))
  )) : (
    message.error(response.status)
  )
}

export default requestHandler
